/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-crop': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15.625 12.5h-1.25V5.625H7.5v-1.25h6.875c.69 0 1.25.56 1.25 1.25V12.5zm-10 1.875V1.25h-1.25v3.125H1.25v1.25h3.125v8.75c0 .69.56 1.25 1.25 1.25h8.75v3.125h1.25v-3.125h3.125v-1.25H5.625z"/>'
  }
})
